//引入接口文档
import req from '@/utils/req.js'

//患者病程分页查询
export function pageCourse(params) {
  return req.post("/admin/patient-symptom/pageCourse",params);
}

//患者病程分页查询
export function pageCourseNew(params) {
  return req.post("/admin/patient-symptom/pageCourseNew",params);
}

// 通过患者id获取当前档案病种和治疗阶段
export function getArchiveDiseaseAndTherapyStage(params) {
  return req.get("/admin/patient-archives/getArchiveDiseaseAndTherapyStage",params);
}

// 删除病程症状
export function deleteCourseSymptom(params) {
  return req.delete(`/admin/patient-symptom/deleteCourseSymptom?patientCourseSymptomId=${params}`, {});
}

// 时间类型下拉列表
export function getDateNameList() {
  return req.get("/admin/patient-symptom/dateNameList");
}

//患者病程生化指标记录
export function anomalyHistory(params) {
  return req.post("/admin/ocr-anomaly-index/history",params);
}
//患者问询推送记录
export function symptomsRecordsPage(params) {
  return req.post("/biz/patient-symptom-push-record/admin/patientSymptomsRecordsPage",params);
}
//患者当前症状分页查询
export function pageSymptom(params) {
  return req.post("/admin/patient-symptom/page",params);
}

// 获取当前症状的症状程度列表 
export function pageSymptomLevelList(params) {
  return req.post("/admin/patient-symptom/symptomLevelList",params);
}

//患者新增症状分页查询
export function patientSavePage(params) {
  return req.post("/admin/symptom/patientSavePage",params);
}

//患者添加症状
export function saveCourseSymptom(params) {
  return req.post("/admin/patient-symptom/saveCourseSymptom",params);
}

//病程记录修改
export function updateCourseSymptom(params) {
  return req.put("/admin/patient-symptom/updateCourseSymptom",params);
}

//结束症状
export function endedSymptomById(params,endTime) {
  return req.put(`/admin/patient-symptom/endedSymptomById?id=${params}&endTime=${endTime}`);
}

// 编辑症状
export function editSymptomSeverity(params) {
  return req.put(`/admin/patient-symptom/editSymptomSeverity`, params);
}

//标准症状分页查询
export function pageStandardSymptom(params) {
  return req.post("/admin/symptom/page",params);
}

//患者新增症状操作
export function mergeOrSave(params) {
  return req.post("/admin/symptom/mergeOrSave",params);
}

//获取用户信息
export function getUserInfo(params) {
  return req.get("/admin/user-info",params);
}

//检验
export function pageInspectionInfo(params) {
  return req.post("/admin/inspection-info/page",params);
}

//检查
export function pageExamineInfo(params) {
  return req.post("/admin/examine-info/page",params);
}

// 更新关联记录状态至初始状态 
export function updatePatientDateMapping(patientCourseSymptomId) {
  return req.put(`/biz/patient-date-scheme-course-mapping/update-patient-date-mapping/${patientCourseSymptomId}`);
}